
const programs ={
    weight_loss: {
        name: "Weight Loss",
        wellness_assessment: true,
        physical_readiness: true,
        movement_assessment: true,
        goal_development: true,
        review_habits: true,
        inbody_body_comp: "2x",
        resting_metabolic_rate: true,
        vo2_max: false,
        initial_consulation: true,
        meal_plan_development: true,
        shopping_list: true,
        thirty_minute_virtual_touchpoint: true,
        fifteen_minute_virtual_touchpoint: "4x",
        training_plan_development: true,
        thirty_minute_virtual_pt: "18x",
        sixty_minute_virtual_pt: false,
        communicate_with_coaches: true,
        access_educational_content: true,
        track_progress: true,
        access_recipes: true,
        create_healthy_habits: true,
        price: 695,
        session: [
            {name: "30min Virtual", price: 695, add_six_weeks: 495},
            {name: "60min Virtual", price: 965, add_six_weeks: 765},
            {name: "60min In Person", price: 1235, add_six_weeks: 1035}
        ]
    },
    get_fit: {
        name: "Get Fit",
        wellness_assessment: true,
        physical_readiness: true,
        movement_assessment: true,
        goal_development: true,
        review_habits: true,
        inbody_body_comp: "2x",
        resting_metabolic_rate: true,
        vo2_max: true,
        initial_consulation: true,
        meal_plan_development: true,
        shopping_list: true,
        thirty_minute_virtual_touchpoint: true,
        fifteen_minute_virtual_touchpoint: "4x",
        training_plan_development: true,
        thirty_minute_virtual_pt: false,
        sixty_minute_virtual_pt: "18x",
        communicate_with_coaches: true,
        access_educational_content: true,
        track_progress: true,
        access_recipes: true,
        create_healthy_habits: true,
        price: 1055,
        session: [
            {name: "60min Virtual", price: 1055, add_six_weeks: 765},
            {name: "60min In Person", price: 1325, add_six_weeks: 1035}
        ]
    },
    stay_fit: {
        name: "Stay Fit",
        wellness_assessment: true,
        physical_readiness: true,
        movement_assessment: true,
        goal_development: true,
        review_habits: true,
        inbody_body_comp: "2x",
        resting_metabolic_rate: false,
        vo2_max: false,
        initial_consulation: true,
        meal_plan_development: false,
        shopping_list: false,
        thirty_minute_virtual_touchpoint: false,
        fifteen_minute_virtual_touchpoint: false,
        training_plan_development: true,
        thirty_minute_virtual_pt: false,
        sixty_minute_virtual_pt: "18x",
        communicate_with_coaches: true,
        access_educational_content: true,
        track_progress: true,
        access_recipes: true,
        create_healthy_habits: true,
        price: 750,
        session: [
            {name: "60min Virtual", price: 750, add_six_weeks: 630},
            {name: "60min In Person", price: 1020, add_six_weeks: 900}
        ]
    },
    keep_moving: {
        name: "Keep Moving",
        wellness_assessment: true,
        physical_readiness: true,
        movement_assessment: true,
        goal_development: true,
        review_habits: true,
        inbody_body_comp: "2x",
        resting_metabolic_rate: true,
        vo2_max: false,
        initial_consulation: true,
        meal_plan_development: true,
        shopping_list: true,
        thirty_minute_virtual_touchpoint: false,
        fifteen_minute_virtual_touchpoint: "2x",
        training_plan_development: true,
        thirty_minute_virtual_pt: "18x",
        sixty_minute_virtual_pt: false,
        communicate_with_coaches: true,
        access_educational_content: true,
        track_progress: true,
        access_recipes: true,
        create_healthy_habits: true,
        price: 605,
        session: [
            {name: "30min Virtual", price: 605, add_six_weeks: 435},
            {name: "60min Virtual", price: 875, add_six_weeks: 705},
            {name: "60min In Person", price: 1145, add_six_weeks: 975}
        ]
    },
    compare: {
        name: "Compare ?", //defailt get fit
        wellness_assessment: false,
        physical_readiness: false,
        movement_assessment: false,
        goal_development: false,
        review_habits: false,
        inbody_body_comp: false,
        resting_metabolic_rate: false,
        vo2_max: false,
        initial_consulation: false,
        meal_plan_development: false,
        shopping_list: false,
        thirty_minute_virtual_touchpoint: false,
        fifteen_minute_virtual_touchpoint: false,
        training_plan_development: false,
        thirty_minute_virtual_pt: false,
        sixty_minute_virtual_pt: false,
        communicate_with_coaches: false,
        access_educational_content: false,
        track_progress: false,
        access_recipes: false,
        create_healthy_habits: false,
        price: 0,
        session: [
            {name: "60min Virtual", price: 1055, add_six_weeks: 765}
        ]
    },
}

export { programs };